export const NotificationManager = {
    async requestPermission() {
        if (!('Notification' in window)) {
            console.error('This browser does not support notifications.');
            return false;
        }

        const permission = await Notification.requestPermission();
        return permission === 'granted';
    },

    async subscribeUser() {
        if (!('serviceWorker' in navigator)) return;

        const registration = await navigator.serviceWorker.ready;

        // In a real app, you'd fetch the public VAPID key from the server
        // For now, we'll use a placeholder or check if a subscription exists
        try {
            const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: 'BPNp-P6_rW9-0Q2t8R5S3bW-7O4S5X8Z8_placeholder_key_here'
                // Note: This is a placeholder. Real VAPID keys are needed for actual push.
            });

            console.log('User is subscribed:', subscription);
            // Here you would send the subscription to your backend (D1/Cloudflare)
            return subscription;
        } catch (err) {
            console.error('Failed to subscribe the user: ', err);
        }
    },

    async sendTestNotification() {
        if (Notification.permission === 'granted') {
            const registration = await navigator.serviceWorker.ready;
            registration.showNotification('Daily Fit Test', {
                body: 'Your habits are waiting for you!',
                icon: '/icons/icon-192x192.png'
            });
        }
    }
};
